import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-inv-forms';

import { MaintenanceModePageWrapper } from './style';

interface Props {
  /** akcja zamknięcia zakładki */
  closeTab: VoidFunction;
}

/**
 * Komponent braku dostępu do zakładki, pokazuje się w momencie kiedy user będzie miał otwartą zakładkę, do której nie ma dostępu.
 *
 */
const NoAccess: React.FunctionComponent<Props> = (props: Props) => {
  const { t } = useTranslation();

  return (
    <MaintenanceModePageWrapper>
      <section className='header'>
        <img src={require('../../../images/logo_full_color.svg')} alt='logo' />
      </section>
      <section className='content'>
        <h1>{t('NO_ACCESS_TITLE')}</h1>
        <h2>{t('NO_ACCESS_SUBTITLE')}</h2>
        <ul>
          <li>{t('NO_ACCESS_NO_ACCESS')},</li>
          <li>{t('NO_ACCESS_NOT_FOUND')},</li>
          <li>{t('NO_ACCESS_UNKNOWN_ERROR')}.</li>
        </ul>
        <Button onClick={props.closeTab}>{t('CLOSE_TAB')}</Button>
        <img src={require('../../../images/UCI_logo_color.png')} alt='logo_UCI' />
        <h4 className='withBold'>{t('MAINTENANCE_MODE_PAGE_BOK_TITLE')}</h4>
        {t('MAINTENANCE_MODE_PAGE_BOK_CONTACT')}
        <h5>{t('MAINTENANCE_MODE_PAGE_BOK_CONTACT_NET')}</h5>
        <h4>{t('MAINTENANCE_MODE_PAGE_BOK_EMAIL')}</h4>
      </section>
    </MaintenanceModePageWrapper>
  );
};

export default NoAccess;
